export enum WIDGET_IFRAME_KEYS {
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=210529754
     * */
    IFRAME = 'SEARCH_SETTINGS.IFRAME_SOURCE_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=765014355
     * */
    IFRAME_WIDGET_SETTINGS_TITLE = 'DESIGNER.IFRAME_WIDGET_SETTINGS_TITLE',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=642157552
     * */
    OPEN_IN_NEW_TAB_LABEL = 'WIDGET_IFRAME_SETTINGS.OPEN_IN_NEW_TAB_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=642157924
     * */
    USE_IFRAME_URL_LABEL = 'WIDGET_IFRAME_SETTINGS.USE_IFRAME_URL_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=642163624
     */
    USE_CUSTOM_URL_LABEL = 'WIDGET_IFRAME_SETTINGS.USE_CUSTOM_URL_LABEL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=765017041
     * */
    WRITER_MODE_EMPTY_STATE_TITLE = 'WIDGET_IFRAME_SETTINGS.NO_IFRAME_TITLE',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454396
     * */
    DISPLAY_BORDER = 'WIDGET_TYPE_IFRAME_DISPLAY_BORDERS',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454395
     * */
    DISABLE_SCROLL = 'WIDGET_TYPE_IFRAME_DISABLE_SCROLL',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=10391542
     * */
    SEND_USER_IDENTITY = 'FRONT.IFRAME.USER_IDENTITY_NAME',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=10391543
     * */
    SEND_USER_IDENTITY_HELPER = 'FRONT.IFRAME.USER_IDENTITY_HELP',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=76455434
     * */
    SEND_CONTENT_ID = 'FRONT.IFRAME.CONTENT_ID_NAME',
    /**
     * https://app.lokalise.com/project/9908543959143d288486e6.27339719/?k=76456131
     * */
    SEND_CONTENT_ID_HELPER = 'FRONT.IFRAME.CONTENT_ID_HELP',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454401
     * */
    IFRAME_SETTINGS_WIDTH = 'WIDGET_TYPE_IFRAME_SETTINGS_WIDTH',
    /**
     * https://app.lokalise.com/project/971428945b55f3d6334c27.85957847/?k=13454398
     * */
    IFRAME_SETTINGS_HEIGHT = 'WIDGET_TYPE_IFRAME_SETTINGS_HEIGHT',
}
